export enum OperationType {
	Update = 1,
	Register = 2,
}
